var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTasks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4996 3.16667V2.27833H5.25021C5.25021 1.29582 6.03364 0.5 7 0.5C7.96635 0.5 8.74979 1.29584 8.74979 2.27833H10.4996L10.5004 3.16667C10.5004 3.40251 10.4077 3.62917 10.2436 3.79583C10.0795 3.96249 9.85725 4.05584 9.62508 4.05584H4.37487C3.89169 4.05584 3.49956 3.6575 3.49956 3.16667H3.4996ZM11.8122 2.32251L11.813 3.16667C11.8113 4.39333 10.8327 5.38747 9.6251 5.38917H4.3749C3.16735 5.38751 2.18871 4.39333 2.18703 3.16667V2.32251C0.926158 2.5375 0.00168007 3.64583 0 4.94501V13.8333C0 15.3067 1.17474 16.5 2.6251 16.5H11.3749C12.8253 16.5 14 15.3067 14 13.8333V4.94501C13.9984 3.64586 13.0738 2.53755 11.813 2.32251H11.8122Z",
    fill: "#191938"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.98f7aea17dd687706e71da46bf66d876.svg";
export { ForwardRef as ReactComponent };